<div *ishIsAuthorizedTo="'APP_B2B_MANAGE_ORDERS'">
  <ish-lazy-buyers-select [control]="formControl" [field]="field" data-testing-id="buyers-select" />
</div>
